import { defineStore } from "pinia";

import type { SignDocumentsState } from "./Models/State";
import type { SignDocument } from "./Models/Domain";
import { StateNamespace } from "@/Modules/App/Models/State/StateNamespace";

import fetchSignDocumentsActionHandler from "./ActionHandlers/FetchSignDocuments";
import sendDocumentToClientActionHandler from "./ActionHandlers/SendDocumentToClient";
import fetchSignDocumentActionHandler from "./ActionHandlers/FetchSignDocument";
import updateResponsesActionHandler from "./ActionHandlers/UpdateResponses";
import doSignDocumentActionHandler from "./ActionHandlers/DoSignDocument";
import getDownloadLinkActionHandler from "./ActionHandlers/GetDownloadLink";
import RejectDocumentActionHandler from "./ActionHandlers/RejectDocument";
import RemoveDocumentActionHandler from "./ActionHandlers/RemoveDocument";
import FetchSignDocumentsStatsActionHandler from "./ActionHandlers/FetchSignDocumentsStats";

import { hasValue } from "@/Utils/Objects";

const state: SignDocumentsState = {
  isLoading: false,
  documents: [],
};

export const useSignDocumentsStore = defineStore(StateNamespace.SIGN_DOCUMENTS, {
  state: () => ({ ...state }),
  getters: {},

  actions: {
    addDocument(doc: SignDocument) {
      if (hasValue(this.documents)) {
        const index = this.documents.findIndex((d) => d.uuid === doc.uuid);

        if (index > -1) {
          this.documents[index] = doc;
        } else {
          this.documents = [doc, ...this.documents];
        }
      } else {
        this.documents = [doc];
      }
    },

    fetchSignDocuments: fetchSignDocumentsActionHandler,
    sendDocumentToClient: sendDocumentToClientActionHandler,
    fetchSignDocument: fetchSignDocumentActionHandler,
    updateResponses: updateResponsesActionHandler,
    doSignDocument: doSignDocumentActionHandler,
    getDownloadLink: getDownloadLinkActionHandler,
    rejectDocument: RejectDocumentActionHandler,
    removeDocument: RemoveDocumentActionHandler,
    fetchSignDocumentsStats: FetchSignDocumentsStatsActionHandler,
  },
});

export type SignDocumentsStoreType = ReturnType<typeof useSignDocumentsStore>;

export default useSignDocumentsStore;
